module.exports = __webpack_public_path__ + "img/neh__logo_hor_grayscale_small.63a12720.jpg";